const EN = {
    title: 'Payment Links',
    subtitle: 'Payment Link', /* se usa en submenu link de pago en detalles de cliente */
    table: {
        title: 'Payment links list',
        columns: {
            linkNumber: 'Link N°',
            client: 'Seller',
            dni: 'INE',
            description: 'Description',
            amount: 'Amount',
            createdAt: 'Creation Date',
            paymentDate: 'Latest payment attempt',
            status: 'Status',
            paymentLinkPosition: 'Payment link position'
        },
        filter: {
            0: {
                0: 'Pending',
                1: 'Confirmed',
                2: 'Rejected',
                3: 'Expired',
                title: 'Status'
            },
            1: {
                0: 'Diamond',
                1: 'Sapphire',
                2: 'Gold',
                3: 'Silver',
                4: 'Bronze',
                title: 'Level'
            },
        },
    }
};

export default EN;
